import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, checkStatusForServiceAreaSubAfterTryAgain } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitCheckStatusForServiceAreaSubAfterTryAgainApi = createAsyncThunk(
  "hitCheckStatusForServiceAreaSubAfterTryAgainApi",
  async (customerId) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
         // Authorization: `${token}`,
        },
      };
      const url = ApiBaseUrl + checkStatusForServiceAreaSubAfterTryAgain + "/" + customerId;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      showToast(error?.response?.data?.message || "Something went wrong", "error");
      throw error?.response?.data || error;
    }
  }
);

const checkStatusForServiceAreaSubAfterTryAgainSlice = createSlice({
  name: "checkStatusForServiceAreaSubAfterTryAgainReducer",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  reducers: {
    clearCheckStatusForServiceAreaSubAfterTryAgainData: (state) => {
      state.data = null;
      state.isError = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitCheckStatusForServiceAreaSubAfterTryAgainApi.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(hitCheckStatusForServiceAreaSubAfterTryAgainApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitCheckStatusForServiceAreaSubAfterTryAgainApi.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const { clearCheckStatusForServiceAreaSubAfterTryAgainData } = checkStatusForServiceAreaSubAfterTryAgainSlice.actions;
export default checkStatusForServiceAreaSubAfterTryAgainSlice.reducer;
